import { palette } from 'src/styles/colors';
import styled from 'styled-components';

export const HighlightMetricsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1px 1fr 1px 1fr;
  margin-bottom: 2rem;
`

export const HighlightMetric = styled.div`
  display: grid;
  row-gap: 0.5rem;
  grid-template-rows: 46px 1fr;
  box-sizing: border-box;
  padding-left: 5px;
  padding-right: 5px;

  .gatsby-image-wrapper {
    justify-self: center;
    align-self: center;
    height: 100%;
  }
`

export const Divider = styled.div`
  border-left: 1px solid ${palette.footerBackground};
  height: 100%;
  width: 0px;
`
